<template>
    <form-field v-bind="fieldProps">
        <multi-select-input
            v-bind="inputProps"
            :style="grayColor ? 'background-color: #f5f5f5' : ''"
            :expandable="expandableOptions"
            :oneOptionSelected="oneOptionSelected"
            @change="change($event)"
            @emitEvent="emitEvent($event, ['change'])"
        ></multi-select-input>

        <template #hint>
            <slot name="hint"></slot>
        </template>

        <template #right>
            <slot name="right"></slot>
        </template>

        <template #error="{ error }">
            <slot name="error" :error="error"></slot>
        </template>
    </form-field>
</template>

<script>
    import FormFieldMixin from 'mixins/FormFieldMixin'

    export default {
        mixins: [FormFieldMixin],

        props: {
            expandableOptions: { type: Boolean, default: false },
            placeholder: { type: String, default: undefined },
            options: { type: Array, required: true },
            grayColor: { type: Boolean, default: false },
            oneOptionSelected: { type: Boolean, default: false },
            showSelectAllOption: { type: Boolean, default: false },
        },
    }
</script>
